import React from 'react';

import UnmountablePureComponent from 'js/src/components/common/UnmountablePureComponent';

/*
The GenericBasePreviewElement is a React Component that is never actually instantiated.
It's a generic base class that specifies typescript types for the components that inherit
from it.

The `<VideoPreview/>` component calls some methods of its child components (like `ref.play()`).
This class specifies types for these methods.
*/
class GenericBasePreviewElement<Props, State> extends UnmountablePureComponent<Props, State> {
    play(opts = { firstPlay: true }): Promise<void> {
        throw new Error('must be implemented by child class');
    }

    pause(): Promise<void> {
        throw new Error('must be implemented by child class');
    }

    stop(): Promise<void> {
        throw new Error('must be implemented by child class');
    }

    override render() {
        return <></>;
    }
}

export default GenericBasePreviewElement;
